module.exports = __webpack_public_path__ + "static/media/faq-item-5.06511a0c.png";